module.exports = __webpack_public_path__ + "img/group_top.76469e79.png";